import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription, throwError } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import ReactCalendar from 'src/app/React-components/React-calendar/ReactCalendar';
import { IMyComponentProps } from '../../React-components/React-calendar/ReactCalendar';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { SearchService } from 'src/app/service/search.service';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/service/utility.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { AttendeeService } from 'src/app/service/attendee.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { MeetingResponse } from 'src/app/models/basicMeetingModel';
import { ConfidentialDialogComponent } from 'src/app/components/confidential-dialog/confidential-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// import ReactCalendar from 'src/app/React-components/React-calendar/ReactCalendar';

@Component({
  selector: 'app-meeting-details',
  templateUrl: './meeting-details.component.html',
  styleUrls: ['./meeting-details.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MeetingDetailsComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  [x: string]: any;
  // @ViewChild('sidenav')
  // public sidenav!: MatSidenav;
  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;

  drawerBoolean!: any

  @Input() myEvents!: IMyComponentProps;
  @Output() tirggerEvent = new EventEmitter<any>();
  eventObject: any;
  slotEventObject: any;
  navigateCalendarDate: any;
  startdate: any;
  enddate: any;
  jsonReq: any;
  element: any;
  searchJSON: any;
  httpHeaders: any;
  error!: string;
  isLoading: boolean = false;
  jsondata: any;
  meetingEnded = false
  calView='month';
  meetingResponse!: MeetingResponse;
  constructor(private readonly breakpointObserver: BreakpointObserver,private dialog: MatDialog,public mediaObserver: MediaObserver,private webTranService:WebsocketTransferService, private sidenavService: SideNavServiceService, private http: HttpClient, private searchService: SearchService, public router : Router,private utilityService: UtilityService, private globals: Globals,private meetingService: MeetingService,private attendeeService:AttendeeService,private spinner: NgxSpinnerService,private route: ActivatedRoute) {

    this.httpHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");

    var currentDate = new Date();
    this.getMeetingDetails(currentDate);


  }
  getMeetingDetails(currentDate: any) {
 
    var myStartDate = new Date(currentDate);
    myStartDate.setDate(currentDate.getDate() - 30);
    var myEndDate = new Date(currentDate);
    myEndDate.setDate(currentDate.getDate() + 30);
    this.jsonReq =
    {
      "startDate": myStartDate.getTime(),
      "endDate": myEndDate.getTime(),
      "userId": localStorage.getItem("userId"),
      "visitorTimeZone": this.globals.vTimeZone
    }
    this.isLoading = true;
    this.loadMeetingDetails(this.jsonReq);
    this.isLoading = false;
  }
  loadMeetingDetails(searchJSON: any) {
    this.spinner.show()
    let searchResp = this.searchService.loadMeetingDetails(searchJSON);
    searchResp.subscribe(
      (response) => {
        let message = JSON.stringify(response);
        this.jsondata = JSON.parse(message);
        
        this.render(this.jsondata);
        this.isLoading = false;
        this.spinner.hide()
      },
      (error: string) => {
        this.error = error;
        this.isLoading = false;
      });

  }

  triggerEvent(res: any) {
  }

  public calendarId = "calendarId";

  ngOnChanges(changes: SimpleChanges): void {
    this.render(this.jsondata)
  }

  ngAfterViewInit(): void {
    this.render(this.jsondata)
  }

  ngOnInit(): void {
    this.sidenavService.setSidenav(this.sidenav)
  this.mediaSub = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]).subscribe(result => {
    const breakpoints = result.breakpoints;

    this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
    this.deviceSm = breakpoints[Breakpoints.Small] || false;
    this.deviceMd = breakpoints[Breakpoints.Medium] || false;
    this.deviceLg = breakpoints[Breakpoints.Large] || false;
    this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
  });
  }

  ngOnDestroy() {
    this.mediaSub?.unsubscribe();
  }

  
  private render(jsondata: any) {
    const myEvents: IMyComponentProps = {
      events: jsondata,
      scheduledEventTriggered: (res: any) => {//while clicking on meeting/task
        this.eventObject = res;
        var meetingJson={
             
          "meetingStatusCode": this.eventObject.status,
          "isConfidential":this.eventObject.isConfidential,
          "meetingId": this.eventObject.id,
          "meetingTitle": this.eventObject.title
        }
this.meetingService.fetchMeetingWithStatusObject(this.eventObject.id).subscribe(
          (meetingRes: any) => {
            var meetingobject=meetingRes.body
        if(res!=null && res.calendarType!="OUTLOOK" && res.calendarType!="GOOGLE" && res.calendarType!="ZOOM"){
          if(this.eventObject.isConfidential=='Y' || this.eventObject.isConfidential=='YES'){
            if(meetingobject.meetingStatusCode == "SCH" ){
              let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
                panelClass: ['animate__animated', 'animate__slideInRight'],
                disableClose: true,
                position: {
                  left: "50%"
                },
                maxWidth: "100%",
                maxHeight: "100vh",
                width: "50%",
                height: "100vh",
                data:(meetingobject.rescheduleflag=="Y" && (meetingobject.meetingStartFlag == null||meetingobject.meetingStartFlag == undefined) ? { isConfidentialCheck: true, meetingObj: meetingJson,flag:true,meetingStartFlag:""}:{ isConfidentialCheck: true, meetingObj: meetingJson,flag:true,meetingStartFlag:"Y"})
              })
          }else{

            let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
              panelClass: ['animate__animated', 'animate__slideInRight'],
              disableClose: true,
              position: {
                left: "50%"
              },
              maxWidth: "100%",
              maxHeight: "100vh",
              width: "50%",
              height: "100vh",
              data: { isConfidentialCheck: true, meetingObj:meetingJson,flag:true,showMoM : true}
            })

          }
        }else{
            if(this.eventObject.isDummyLink=="Y"){
              this.createRecurChildMeetingCal(this.eventObject);
            }else{
              if(meetingobject.meetingStatusCode == "SCH" ){
                if(meetingobject.rescheduleFlag=="Y" && (meetingobject.meetingStartFlag == null||meetingobject.meetingStartFlag == undefined)){
                this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingobject.meetingId,"meetingStartFlag":"" }) }, skipLocationChange: true, replaceUrl: false });                  
                }else{
                  this.sidenavService.openInstantMeeting(true);
                  this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingobject.meetingId,"meetingStartFlag":"Y" }) }, skipLocationChange: true, replaceUrl: false });                    
                }
              }
              else{
                this.redirectToPastMeeting(this.eventObject.id)
              }
            }
       	 }
        }
      });
      },
      onView:(view:any)=>{
        this.calView=view;
      },
      slotEventTrigger: (res: any) => {
        this.slotEventObject = res;
        this.createNewMeeting(this.slotEventObject);
      },
      navigateTrigger: (res: any) => {
        var triggerdate = new Date(res);
        this.getMeetingDetails(triggerdate);
        this.navigateCalendarDate = new Date(res);
      },
      styleSetter: (res : any) => {

        return{
          style: { background: res.color }
        }
      }
    };
    ReactDom.render(React.createElement(ReactCalendar, myEvents), document.getElementById(this.calendarId))
  }

createRecurChildMeetingCal(event:any){
  var reqJson ={
    "recurDetailsId": event.id,
    "meetingDateStr": moment(new Date(event.startTime)).utcOffset(this.globals.vTimeZoneOffset).format('MMM DD, yyyy'),
    "meetingStartTime": moment(new Date(event.startTime)).utcOffset(this.globals.vTimeZoneOffset).format('HH:mm'),
     "orgCode": this.globals.orgCode,
     "userId": this.globals.userId,
     "visitorTimeZone": this.globals.vTimeZone,  
  }
  
  this.meetingService.createRecurChildMeeting(reqJson).subscribe(res => {
    
    if(res!=null && res.body!=null && res.body.meetingId!=null){
      this.redirectToMeeting(res.body.meetingId);  
    }
  });
}

  createNewMeeting(event : any) {
    this.spinner.show();
    this.meetingObj = {};
      this.meetingObj = {
        "meetingDateStr": new Date(event.start).toLocaleDateString('en-US',{month: 'short',day: 'numeric',year: 'numeric' }),
       // "meetingStartTime": new Date(event.start).toLocaleTimeString('en-US', {hour12: false, hour: '2-digit', minute: '2-digit' }) == '24:00' ? this.utilityService.nvl(this.utilityService.getDefaultMeetingTime()) : new Date(event.start).toLocaleTimeString('en-US', {hour12: false, hour: '2-digit', minute: '2-digit' }),
       "meetingTitle" : environment.defMeetingTitle,
        "orgCode": this.globals.orgCode,
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone,
        "duration": environment.defMeetingDuration,
        "logType":this.globals.logType
      }
      if(this.calView!=undefined && this.calView!='month'){
        this.meetingObj.meetingStartTime=new Date(event.start).toLocaleTimeString('en-US', {hour12: false, hour: '2-digit', minute: '2-digit' });
      }else{
        this.meetingObj.meetingStartTime= this.utilityService.nvl(this.utilityService.getDefaultMeetingTime())
      }
     
      this.meetingService.createNewMeeting(this.meetingObj).subscribe(data => {
        if (data != null && data != undefined && data.body != null && data.body != undefined) {
          if (data.body.meetingId != null) {
            ////consolee.log("meeting>>" + JSON.stringify(data.body));
            // if(event.start >= Date.now()){
              if(data.body.meetingEndFlag!=undefined && data.body.meetingEndFlag=="Y"){
                this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : data.body.meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });  
              }else{
                this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify(data.body)}, skipLocationChange: true, replaceUrl: false });
              }   
          }
        }
        this.spinner.hide();
      },
        err => {
          this.spinner.hide();
        }).add(() => {
          //Called when operation is complete (both success and error)
        });
    //} 
  }

  startMeeting(meetingId:any){
    var jsonObj = {
      "meetingId":meetingId,
      "userId":localStorage.getItem("userId")
    }
    this.meetingService.startMeeting(jsonObj).subscribe((meetingRes: any) => {
        //
        this.sidenavService.openInstantMeeting(true);
        var reqJson={"meetingId":meetingId,"userId":localStorage.getItem("userId"),"loggedStatus":"LOGIN"}
        this.webTranService.pushUserLoggedInStatus(meetingId,reqJson).subscribe((data) => {
        });
        this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingId }) }, skipLocationChange: true, replaceUrl: false });  
       },
      err => {
        //
      });

   }
   redirectToMeeting(meetingId:number){
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingId }) }, skipLocationChange: true, replaceUrl: false });  
   } 
   closeInstantMeeting(meetingResponse: any){
    window.alert("trigggered from close instant meeting")
    var reqJson={"meetingId":meetingResponse,"userId":this.globals.userId,"visitorTimeZone":this.globals.vTimeZone};
 
    this.meetingService.endMeeting(reqJson).subscribe(
      
      (meetingRes: any) => {
        window.alert("service triggered");
        ////consolee.log("meeting resp frm end meeting" + JSON.stringify(meetingRes));
        this.notifier.show({
          type: 'success',
          message: 'Meeting Ended Successfully'
        });
   
        this.meetingResponse = meetingRes.body;
        //this.commonService.shareDatatoService(this.meetingResponse);
        this.meetingEnded = true
        this.sidenavService.openInstantMeeting(false);
        this.meetingResponse.addType='A';
        this.meetingResponse.elementType='ENDMEETING';
        var sentUserName = localStorage.getItem("userName");
        if(sentUserName!=null && sentUserName!=undefined){
          this.meetingResponse.sentByUserName=sentUserName;
        }
        this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
        });
      },
      err => {
        //
        //this.ngxSpinner.hide();
      })
     
  }
  redirectToPastMeeting(meetingId : any){
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });
  }
}
